import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

const AddLocality = () => {

    const userRole = localStorage.getItem("role");
    const userCity = localStorage.getItem("city");
    const loggedUserID = localStorage.getItem("uid");
    const [cities, setCities] = useState([]);
    const [localities, setLocalities] = useState([]);
    const initialFormData = {
        city: "",
        name: ""
    }
    const [formData, setFormData] = useState(initialFormData);
    const navigate = useNavigate();

    const handleChange = (e) => {
        e.preventDefault()

        let name = e.target.name
        let value = e.target.value

        if (name === "phoneNo" || name === "salary") { value = parseInt(value) }

        setFormData({ ...formData, [name]: value })
    }

    // Fetch cities
    const fetchCities = async () => {
        try {
            const res = await HomeService.getCities();
            if (res?.data) {
                setCities(res.data);
                HomeService.getLocalities().then((items) => setLocalities(items?.data || [])).catch(() => toast.error("Unable to load localities."));
                if (userCity) {
                    setCities([res.data.find(item => item._id === userCity)])
                }
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name) return toast.error("Locality should not be empty")
        console.log("HD51", formData);
        // return
        try {
            const res = await HomeService.addLocality(formData);
            if (res?.status) {
                toast.success("Locality added successfully!");

                navigate("/manage-locality");
            }
        } catch (error) {
            toast.error("Failed to add Locality.");
            console.error("Error adding Locality:", error);
        }
    };

    useEffect(() => {
        fetchCities()
    }, [])




    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">
                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Locality
                    </div>
                    <hr />

                    <section className="chartBox_area">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-4 mt-3">
                                    <label>
                                        City<span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="city"
                                        value={formData?.city || ""}
                                        onChange={(e) => handleChange(e)}
                                        required
                                    >
                                        <option value="" disabled>---Select---</option>
                                        {cities.map((city) => (
                                            <option key={city._id} value={city._id}>
                                                {city.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-8 mt-3">
                                    <label htmlFor="designation">
                                        Locality<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="designation"
                                        className="form-control"
                                        name="name"
                                        value={formData?.name || ""}
                                        onChange={(e) => handleChange(e)}
                                        placeholder="Enter Locality"
                                        required
                                    />
                                </div>
                            </div>
                            <button type="submit" className="btn mt-3" style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }}>
                                Add
                            </button>
                        </form>
                    </section>
                    {formData.city && <section className="chartBox_area mt-4"><h4>Localities in {cities.find((city) => city._id === formData.city)?.name || "selected city"}</h4>{localities.filter((locality) => (locality.city?._id || locality.city) === formData.city).length ? <ul className="mb-0">{localities.filter((locality) => (locality.city?._id || locality.city) === formData.city).map((locality) => <li key={locality._id}>{locality.name}</li>)}</ul> : <p className="mb-0 text-muted">No localities have been added for this city yet.</p>}</section>}
                </div>
            </div>
        </div>
    );
}

export default AddLocality
